<div class="file-upload-section">
  <div class="current-file-info">
    <mat-icon class="file-icon">description</mat-icon>
    <div class="file-details">
      <div class="file-name">Current file is part of this data source</div>
      <div class="file-meta">Last updated: {{ dataSource.updatedAt | date:'yyyy-MM-dd HH:mm' }}</div>
    </div>
  </div>

  <div class="replace-file-area">
    <input 
      type="file" 
      #fileInput 
      (change)="onFileSelected($event)"
      accept=".csv,.json,.xml,.xlsx,.xls"
      style="display: none;">
    
    <div *ngIf="!selectedFile" class="file-select-prompt">
      <button mat-raised-button (click)="fileInput.click()" [disabled]="uploading">
        <mat-icon>upload_file</mat-icon>
        Select New File
      </button>
      <p class="helper-text">Replace the current file with a new one</p>
    </div>

    <div *ngIf="selectedFile" class="selected-file-info">
      <div class="file-card">
        <mat-icon class="file-icon">insert_drive_file</mat-icon>
        <div class="file-details">
          <div class="file-name">{{ selectedFile.name }}</div>
          <div class="file-size">{{ getFileSizeString(selectedFile.size) }}</div>
        </div>
        <button mat-icon-button (click)="clearSelection()" [disabled]="uploading">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Upload Progress -->
      <div *ngIf="uploading" class="upload-progress-section">
        <div class="progress-bar-wrapper">
          <div class="progress-label">
            <span class="progress-text">{{ uploadStatusText }}</span>
            <span class="progress-size" *ngIf="uploadProgress > 0 && uploadProgress < 100 && totalBytes > 0">
              {{ getFileSizeString(uploadedBytes) }} of {{ getFileSizeString(totalBytes) }}
            </span>
            <span class="progress-size" *ngIf="uploadProgress === 0 && totalBytes > 0">
              Preparing {{ getFileSizeString(totalBytes) }}...
            </span>
          </div>
          <mat-progress-bar 
            [mode]="uploadProgress === 0 || uploadProgress === 100 ? 'indeterminate' : 'determinate'" 
            [value]="uploadProgress">
          </mat-progress-bar>
        </div>
      </div>
    </div>

    <div *ngIf="uploadError" class="upload-message error">
      <mat-icon>error</mat-icon>
      <span>{{ uploadError }}</span>
    </div>
  </div>
</div>
